/* eslint-disable max-len */
import { ContentService } from '@blk/cwp-ng-framework';
import * as get from 'lodash/get';
import * as sortBy from 'lodash/sortBy';

import { InsightsTransform } from './insights-transform';

export class EquityRiskInsightsTransform extends InsightsTransform {
	private overviewParagraphDCR: string;
	private conclusionParagraphDCR: string;

	constructor(public contentSvc: ContentService) {
		super(contentSvc);
	}

	protected setupContent(): void {
		this.overviewParagraphDCR = this.contentSvc.get(
			'EQ_INSIGHTS_OVERVIEW_DCR',
			'<p>The equity portfolio has an active risk of {0}, which implies a <b>{1} probability</b> that the equity portfolio&#39;s performance could differ materially from the benchmark.</p><p>The <b>two largest active tilts</b> in your equity portfolio are <b>{2}</b> and <b>{3}</b>.</p>'
		);
		this.conclusionParagraphDCR = this.contentSvc.get(
			'EQ_INSIGHTS_CONCLUSION_DCR',
			'<p>The equity portfolio has {0} active risk and could be expected to vary from its benchmark <b>{1}.</p><p>Is the level and source of active risk in line with your intentions?</b></p>'
		);
	}

	protected getEvaluatedOverview(selectedPortfolioIndex: number): string {
		const equityRiskCell = get(this.insightsTab, 'tableData[0].cells[' + selectedPortfolioIndex + '][0]', {});
		if (equityRiskCell.rawValue || equityRiskCell.rawValue === 0) {
			const factorData = [];
			for (let idx = 0; idx < get(this.factorsTab, 'tableData[0].headersX.length'); idx++) {
				if (!get(this.factorsTab, 'tableData[0].headersX[' + idx + '].attribute.ignoreInChart')) {
					factorData.push({
						name: get(this.factorsTab, 'tableData[0].headersX[' + idx + '].formattedValue'),
						value: get(this.factorsTab, 'tableData[0].cells[' + selectedPortfolioIndex + '][' + idx + '].rawValue')
					});
				}
			}
			const factorDataSorted = sortBy(factorData, [data => data.value]);

			return this.overviewParagraphDCR
				.replace('{0}', equityRiskCell.formattedValue)
				.replace('{1}', this.getRisk(+equityRiskCell.rawValue))
				.replace('{2}', factorDataSorted && factorDataSorted.length > 0 && factorDataSorted[factorData.length - 1] ? factorDataSorted[factorData.length - 1].name : 'n/a')
				.replace('{3}', factorDataSorted && factorDataSorted.length > 1 && factorDataSorted[factorData.length - 2] ? factorDataSorted[factorData.length - 2].name : 'n/a');
		} else {
			return null;
		}
	}

	protected getEvaluatedConclusion(selectedPortfolioIndex: number): string {
		const equityRiskCell = get(this.insightsTab, 'tableData[0].cells[' + selectedPortfolioIndex + '][0]', {});

		return equityRiskCell.rawValue || equityRiskCell.rawValue === 0
			? this.conclusionParagraphDCR.replace('{0}', this.getRisk(+equityRiskCell.rawValue)).replace('{1}', this.getBenchmark(+equityRiskCell.rawValue))
			: null;
	}
}
